export default {
    indexPlanTypes: { method: 'get', url: 'emcadmin/plan-types'},
    storePlanTypes: { method: 'post', url: 'emcadmin/plan-types' },
    updatePlanTypes: { method: 'put', url: 'emcadmin/plan-types/{id}'},
    destroyPlanTypes: { method: 'delete', url: 'emcadmin/plan-types/{id}'},
}